import {
  GET_AREA_LIST,
  GET_DIR_LOCATION_LIST,
} from 'fixtures/actions'
import { GET_AREAS, GET_DIR_LOCATIONS } from 'fixtures/api'
import { has, isUndefined } from 'lodash'
import { getAllList } from 'services/cmsService'

const getAllAreasData = (companyCode) => {
  const params = companyCode ? `?companyCode=${companyCode}` : ''
  return async (dispatch) => {
    let data = []
    let newData = await getAllList(`${GET_AREAS}${params}`)
    if (newData && has(newData, 'data') && !isUndefined(newData.data)) {
      data = newData.data
    }

    dispatch({
      type: GET_AREA_LIST,
      payload: data,
    })
  }
}

const getAllDirLocationsData = (companyCode, areaCode) => {
  const params = (companyCode ? `?companyCode=${companyCode}` : '') + (areaCode ? `&areaCode=${areaCode}` : '')
  return async (dispatch) => {
    let data = []
    let newData = await getAllList(`${GET_DIR_LOCATIONS}${params}`)
    if (newData && has(newData, 'data') && !isUndefined(newData.data)) {
      data = newData.data
    }

    dispatch({
      type: GET_DIR_LOCATION_LIST,
      payload: data,
    })
  }
}


export { getAllAreasData, getAllDirLocationsData }
